import AvailabilityError from '~/constants/availabilityError';
import { Availability, AvailabilityResponse } from '~/contracts/vdp';

export default function transformAvailability(
  res: AvailabilityResponse
): Availability {
  const isPendingDealerPurchase = Boolean(
    res.dealerPurchaseInitiatedByUserId && res.isDealerPurchased === null
  );
  const isPendingDealerPurchaseByUser = Boolean(
    isPendingDealerPurchase &&
      res.dealerPurchaseInitiatedByUserId === res.userId
  );

  return {
    ...res,
    error:
      res.error === AvailabilityError.None &&
      isPendingDealerPurchase &&
      !isPendingDealerPurchaseByUser
        ? AvailabilityError.PurchasePending
        : res.error || AvailabilityError.None,
    isPendingDealerPurchase,
    isPendingDealerPurchaseByUser
  };
}
